import { render } from "./Honors.vue?vue&type=template&id=97f98e68"
import script from "./Honors.vue?vue&type=script&lang=js"
export * from "./Honors.vue?vue&type=script&lang=js"

import exportComponent from "E:\\workspace\\digital-gate\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__